import React, { useCallback, useEffect, useState } from "react";
import TestFeatureUnavailableModal from "../TestFeatureUnavailableModal";
import { TEST_FEATURE_UNAVAILABLE_EVENT } from "../../utils/testEnvironment";

const TestFeatureUnavailableListener = () => {
  const [open, setOpen] = useState(false);
  const [featureName, setFeatureName] = useState("This feature");

  const handleClose = useCallback(() => setOpen(false), []);

  useEffect(() => {
    const onUnavailable = (event) => {
      const name = event?.detail?.featureName || "This feature";
      setFeatureName(name);
      setOpen(true);
    };

    window.addEventListener(TEST_FEATURE_UNAVAILABLE_EVENT, onUnavailable);
    return () => {
      window.removeEventListener(TEST_FEATURE_UNAVAILABLE_EVENT, onUnavailable);
    };
  }, []);

  return (
    <TestFeatureUnavailableModal
      open={open}
      onClose={handleClose}
      featureName={featureName}
    />
  );
};

export default TestFeatureUnavailableListener;
